import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'render-errors',
  templateUrl: './render-errors.component.html',
  styleUrls: ['./render-errors.component.scss']
})
export class RenderErrorsComponent implements OnInit {
  @Input('data') myControl!: FormControl;
  lstError: any[] = [];
  error = {};

  constructor(
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.changeToArray(this.myControl);
  }


  changeToArray(obj: any) {
    if (obj == null) { return; }
    if (obj.errors == this.error) {
      return this.lstError;
    }
    this.lstError = [];
    this.error = obj.errors;
    if (obj.errors != null) {
      this.lstError = [];
      for (const key in obj.errors) {
        if(obj.errors[key]?.message) {
          obj.errors[key] = obj.errors[key]?.message
        }else if (obj.errors[key] !== null) {
          switch (key) {
            case 'required':
              obj.errors[key] = this.translate.instant("BASE.REQUIRED_MESSAGE")
              break;
            case 'pattern':
              obj.errors[key] =  obj.errors[key]?.message
              break;
            case 'email':
            case 'emailRules':
              obj.errors[key] = this.translate.instant("BASE.EMAIL_MESSAGE")
              break;
            case 'phoneNumber':
              obj.errors[key] = this.translate.instant("BASE.PHONE_NUMBER_MESSAGE")
              break;
            case 'numberRange':
              obj.errors[key] = (obj.errors[key]?.min !== undefined ? this.translate.instant("BASE.NUMBER_RANGE_MESSAGE") + ` ${obj.errors[key]?.min}` : '') + (obj.errors[key]?.max !== undefined ? ` ${this.translate.instant("BASE.NUMBER_RANGE_MESSAGE_2")} ${obj.errors[key]?.max}` : '')
              break;
            case 'min':
              obj.errors[key] = this.translate.instant("BASE.MIN_MESSAGE") + ` ${obj.errors[key]?.min} `
              break;
            case 'max':
              obj.errors[key] = this.translate.instant("BASE.MAX_MESSAGE") + ` ${obj.errors[key]?.max} `
              break;
            case 'maxlength':
              obj.errors[key] = this.translate.instant("BASE.MAX_LENGTH_MESSAGE") + ` ${obj.errors[key]?.requiredLength} ${this.translate.instant('BASE.CHARACTER')}`
              break;
            case 'minlength':
              obj.errors[key] = this.translate.instant("BASE.MIN_LENGTH_MESSAGE") + ` ${obj.errors[key]?.requiredLength} ${this.translate.instant('BASE.CHARACTER')}`
              break;
            case 'editorMaxLength':
              obj.errors[key] = this.translate.instant("BASE.MAX_LENGTH_MESSAGE") + ` ${obj.errors[key]?.maxLength + `${this.translate.instant('BASE.CHARACTER')}`} (${obj.errors[key]?.actualLength}) `
              break;
            case 'error':
              obj.errors[key] =  obj.errors[key]?.message
              break;
            default:
              break;
          }
        }
        const data = { key: key, value: obj.errors[key] };
        this.lstError.push(data);
      }
    }

    return this.lstError;
  }

}
